import React from 'react';
export function SocialProofBar() {
  return <div className="bg-green-900 py-6 px-4" data-id="element-524">
      <div className="max-w-6xl mx-auto" data-id="element-525">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-0 divide-x divide-green-700" data-id="element-526">
          <div className="flex flex-col items-center justify-center py-3 px-4 text-center" data-id="element-527">
            <span className="text-2xl sm:text-3xl font-bold text-white leading-none" data-id="element-528">
              ⭐ 4.8/5
            </span>
            <span className="text-green-300 text-xs sm:text-sm mt-1.5 font-medium" data-id="element-529">
              Valoración media
            </span>
          </div>
          <div className="flex flex-col items-center justify-center py-3 px-4 text-center" data-id="element-530">
            <span className="text-2xl sm:text-3xl font-bold text-white leading-none" data-id="element-531">
              +10.000
            </span>
            <span className="text-green-300 text-xs sm:text-sm mt-1.5 font-medium" data-id="element-532">
              Clientas satisfechas
            </span>
          </div>
          <div className="flex flex-col items-center justify-center py-3 px-4 text-center border-t lg:border-t-0 border-green-700" data-id="element-533">
            <span className="text-2xl sm:text-3xl font-bold text-white leading-none" data-id="element-534">
              🛡️ 90 días
            </span>
            <span className="text-green-300 text-xs sm:text-sm mt-1.5 font-medium" data-id="element-535">
              Garantía total
            </span>
          </div>
          <div className="flex flex-col items-center justify-center py-3 px-4 text-center border-t lg:border-t-0 border-green-700" data-id="element-536">
            <span className="text-2xl sm:text-3xl font-bold text-white leading-none" data-id="element-537">
              🚚 Gratis
            </span>
            <span className="text-green-300 text-xs sm:text-sm mt-1.5 font-medium" data-id="element-538">
              Envío en España
            </span>
          </div>
        </div>
      </div>
    </div>;
}